// Controls all types of media that can be filtered
export const useMediaTypes = (format: string): string[] | string => {
  switch (format) {
    case "video":
      return "video/mp4";
    case "image":
      return ["image/jpeg", "image/jpg", "image/png"];
    default:
      return format;
  }
};
